<!--
 * @Description: 
 * @version: 
 * @Author: kxl
 * @Date: 2019-12-30 11:12:20
 * @LastEditors: kxl
 -->
<template>
    <CommonBox title="Send Email" @close="$emit('close')" @submit="submit">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">All</el-checkbox>
        <div style="margin: 15px 0;"></div>
        
        <el-checkbox-group v-model="checkedPartnersID" @change="handleCheckedCitiesChange">
       
        <el-checkbox v-for="item in partnerList"
                        :key="item[0].ID"
                        :label="item[0].ID"
                        :value="item[0].ID">
                        {{item[0].CompanyName}}
        </el-checkbox>
       </el-checkbox-group>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    props:{
    },
    data () {
        return {
            checkAll: false,
            isIndeterminate: true,
            checkedPartnersID: [],
            PartnersID: [],
            partnerList:[]
        };
    },
    mounted () {
        this.$http.get("getAccountBindingAll",{},(data)=>{
            data = data.data;
            this.partnerList = data;
            for(let i in data) {
                this.PartnersID.push(data[i].ID);
            }
        });
    },
    methods:{
        submit () {
            this.checkedPartnersID = this.checkedPartnersID.join(";");
            let url = "sendEmailPartner";
            this.$http.put(url,{
                CheckedPartnersID:this.checkedPartnersID  
            },(data)=>{
                this.$baseNotice.message(data.msg);
                this.$emit('close');
            });
        },
        handleCheckAllChange(val) {
            this.checkedPartnersID = val ? this.PartnersID : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.partnerList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.partnerList.length;
        }
    }
};
</script>
